import PropTypes from 'prop-types';
import React from 'react';
import createRosettaContainer from './createRosettaContainer';
import ProductListHeader from '../components/shopping/product_list_header';
import MoreProductsButton from '../components/shopping/more_products_button';
import ProductListHomeCarousel from '../components/shopping/product_list/home_carousel';
import ProductListAbout from '../components/shopping/product_list/product_list_about';
import ProductListNavigationCategories from '../components/shopping/product_list/navigation_categories';
import RosettaFormattedMessage from '../components/common/rosetta_formatted_message';
import {get} from 'lodash';
import Spinner from '../components/common/spinner';
import { SHOPPING_CATEGORY_COLLECTIONS } from '../constants';

const options = {
  displayName: 'ProductListContainer',

  propTypes: {
    productList: PropTypes.shape({
      resultCount: PropTypes.number,
      heroImage: PropTypes.string,
      isShoppingHome: PropTypes.bool,
      isShoppingSalePage: PropTypes.bool
    }),
    shoppingNavigationItems: PropTypes.shape({
      categories: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        path: PropTypes.string,
        is_active: PropTypes.bool,
        name: PropTypes.string
      })),
      subcategories: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        path: PropTypes.string,
        name: PropTypes.string
      })),
      colors: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
      }))
    }).isRequired
  },

  mapStateToProps: (state) => [state, {
    shoppingNavigationItems: state.shoppingNavigation
  }],

  shouldDisplayCondensedNav() {
    return true;
  },

  shouldDisplayAdhesionAd() {
    return false;
  },

  contentAboveModules() {
    const { isShoppingHome, description } = get(this.props, 'productList');
    const { pageTitle } = get(this.props, 'shoppingNavigationItems');
    const shouldShowAbout = isShoppingHome && description && description.length;

    return (
      <div>
        {isShoppingHome &&
          <ProductListHomeCarousel pageTitle={pageTitle} />
        }
        <ProductListHeader {...this.props} />
        {shouldShowAbout &&
          <ProductListAbout {...this.props} />
        }
      </div>
    );
  },

  noResultsMessage() {
    return (
      <div className="module notification no-products-result">
        <RosettaFormattedMessage parentFilename={__filename}
          id="no_results"
          description="Message that appears on product list pages for which there are no products"
          defaultMessage="Bummer! 0 results found"
        />
      </div>
    );
  },

  contentBelowModules() {
    if (get(this.props, 'productList.resultCount') === 0) {
      return this.noResultsMessage();
    }

    let spinner;
    let aboutContent;
    let moreProductsButton;

    if (this.props.api.fetchStatus === 'fetchingOnSamePage') {
      spinner = (<Spinner />);
    }

    const { description, categoryType, isBrandOrRetailerPage, isShoppingHome } = get(this.props, 'productList');

    if (
      description
      && description.length > 0
      && (categoryType !== SHOPPING_CATEGORY_COLLECTIONS && !isBrandOrRetailerPage && !isShoppingHome)) {
      aboutContent = <ProductListAbout {...this.props} />;
    }

    if (get(this.props, 'api.pagination.next')) {
      moreProductsButton = (
        <MoreProductsButton
          api={this.props.api}
          fetchFoundryResponse={this.props.fetchFoundryResponse}
        />
      );
    }

    const footerNavigation = (
      <div className="footer-nav">
        <ProductListNavigationCategories
          categories={get(this.props, 'shoppingNavigationItems.categories', [])}
          className={'nav-wrapper'}
        />
      </div>
    );

    return (
      <div>
        {spinner}
        {moreProductsButton}
        {aboutContent}
        {footerNavigation}
      </div>
    );
  }
};

export const ProductListContainer = createRosettaContainer({
  ...options,
  shouldDecorateContainer: false
});

export default createRosettaContainer(options);
